"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-center"
      offset={24}
      mobileOffset={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 5.5rem)" }}
      gap={8}
      visibleToasts={4}
      duration={4000}
      closeButton
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-popover/95 group-[.toaster]:backdrop-blur-md group-[.toaster]:text-popover-foreground group-[.toaster]:border group-[.toaster]:border-border/60 group-[.toaster]:shadow-2xl group-[.toaster]:shadow-black/20 group-[.toaster]:rounded-xl group-[.toaster]:px-3.5 group-[.toaster]:py-3 group-[.toaster]:text-sm group-[.toaster]:font-medium group-[.toaster]:tracking-tight",
          title: "text-sm font-semibold tracking-tight",
          description: "text-[12.5px] text-muted-foreground leading-snug mt-0.5",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-md group-[.toast]:px-2.5 group-[.toast]:py-1 group-[.toast]:text-xs group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-md group-[.toast]:px-2.5 group-[.toast]:py-1 group-[.toast]:text-xs",
          closeButton:
            "group-[.toast]:bg-background group-[.toast]:border-border/60 group-[.toast]:text-muted-foreground group-[.toast]:hover:text-foreground",
          success: "group-[.toaster]:border-[hsl(var(--accent-cyan)/0.4)]",
          error: "group-[.toaster]:border-destructive/40",
          warning: "group-[.toaster]:border-amber-500/40",
          info: "group-[.toaster]:border-border/60",
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "calc(var(--radius) + 4px)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
